var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconBagBig = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 91.656,
  height: 91.656,
  viewBox: "0 0 91.656 91.656",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1195",
  "data-name": "Group 1195",
  transform: "translate(-342.15 -1981.15)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_80",
  "data-name": "Ellipse 80",
  cx: 44.978,
  cy: 44.978,
  r: 44.978,
  transform: "translate(343 1982)",
  fill: "none",
  stroke: "#153968",
  strokeMiterlimit: 10,
  strokeWidth: 1.7
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_59",
  "data-name": "Line 59",
  y2: 6,
  transform: "translate(387.978 1982)",
  fill: "none",
  stroke: "#153968",
  strokeMiterlimit: 10,
  strokeWidth: 1.7
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_60",
  "data-name": "Line 60",
  x1: 6,
  transform: "translate(343 2026.978)",
  fill: "none",
  stroke: "#153968",
  strokeMiterlimit: 10,
  strokeWidth: 1.7
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_61",
  "data-name": "Line 61",
  x1: 6,
  transform: "translate(426.496 2026.978)",
  fill: "none",
  stroke: "#153968",
  strokeMiterlimit: 10,
  strokeWidth: 1.7
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_62",
  "data-name": "Line 62",
  y2: 6,
  transform: "translate(389.066 2065.5)",
  fill: "none",
  stroke: "#153968",
  strokeMiterlimit: 10,
  strokeWidth: 1.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_164",
  "data-name": "Path 164",
  d: "M443.636,313.895a.655.655,0,0,0-.043-.058.535.535,0,0,0-.029-.065c-.014-.019-.036-.029-.052-.047a.628.628,0,0,0-.1-.1.69.69,0,0,0-.109-.068.672.672,0,0,0-.134-.047.569.569,0,0,0-.068-.025,234.824,234.824,0,0,0-26.6-2.056h-.014a.709.709,0,0,0-.679.5,21.689,21.689,0,0,0-.821,5.713.71.71,0,0,0,.658.709l.388.028c-.718,4.165-4.159,24.654-5.719,43.212a.711.711,0,0,0,.553.754,254.3,254.3,0,0,0,25.233,3.962.677.677,0,0,0,.075,0h0c.03,0,.061,0,.092-.007a32.068,32.068,0,0,0,8.3-2.409,31.7,31.7,0,0,0,7.892-.03.71.71,0,0,0,.607-.744C453.039,362.8,451.111,330.025,443.636,313.895Zm-2.11,7.147a.634.634,0,0,0,.1.008.7.7,0,0,0,.317-.086c2.185,20.164,1.214,33.7,1.046,35.718a47.742,47.742,0,0,0-6.042,6.682,389.467,389.467,0,0,1,3.9-42.418Zm1.486-3.261c.083-.36.168-.744.251-1.144,5.633,14.057,7.738,37.775,8.247,44.65-1.67-1.2-4.7-3.312-7.091-4.662C444.638,353.881,445.586,339.17,443.012,317.781Zm-25.992-4.914a237.794,237.794,0,0,1,25.153,1.929c-.346,1.978-.818,3.836-1.064,4.751-9.875-1.391-21.771-2.334-24.7-2.556A21.065,21.065,0,0,1,417.02,312.866Zm.428,5.63c3.908.308,13.485,1.115,22,2.256a392.426,392.426,0,0,0-3.963,44.065c-11.582-1.256-21.242-3.206-23.706-3.723C413.37,342.568,416.791,322.3,417.448,318.5Zm27.114,43.969a.706.706,0,0,0-.413.059,31.96,31.96,0,0,1-6.333,2.074,45.3,45.3,0,0,1,5.96-6.708c2.408,1.366,5.554,3.578,7.13,4.711A28.624,28.624,0,0,1,444.562,362.466Z",
  transform: "translate(-43.805 1688.233)",
  fill: "#153968",
  stroke: "#153968",
  strokeWidth: 0.7
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBagBig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_bag_big.43119705.svg";
export { ForwardRef as ReactComponent };